<template>
  <div class="flex min-h-screen bg-[rgb(18,18,18)]">
    <!-- Sidebar -->
    <div class="w-64 bg-[rgb(18,18,18)] border-r border-gray-800 p-4 flex flex-col">
      <div class="flex items-center mb-8">
        <img src="/assets/img/devil.svg" alt="Logo" class="w-8 h-8 mr-2" />
        <div class="text-white font-cinzel">Welcome, marc</div>
      </div>
      
      <nav class="space-y-2">
        <NuxtLink to="/admin" class="bg-red-500 text-white p-3 rounded-lg flex items-center">
          <div class="mr-3">
            <img src="/assets/img/dashboard.png" alt="Dashboard" class="w-5 h-5" />
          </div>
          Dashboard
        </NuxtLink>
        
        <NuxtLink to="/admin/campaigns" class="text-gray-400 p-3 rounded-lg flex items-center hover:bg-gray-800">
          <div class="mr-3">
            <img src="/assets/img/campaigns.png" alt="Campaigns" class="w-5 h-5" />
          </div>
          Campaigns
        </NuxtLink>

        <NuxtLink to="/admin/templates" class="text-gray-400 p-3 rounded-lg flex items-center hover:bg-gray-800">
          <div class="mr-3">
            <img src="/assets/img/templates.png" alt="Templates" class="w-5 h-5" />
          </div>
          Templates
        </NuxtLink>

        <NuxtLink to="/admin/reports" class="text-gray-400 p-3 rounded-lg flex items-center hover:bg-gray-800">
          <div class="mr-3">
            <img src="/assets/img/reports.png" alt="Reports" class="w-5 h-5" />
          </div>
          Reports
        </NuxtLink>

        <NuxtLink to="/admin/customers" class="text-gray-400 p-3 rounded-lg flex items-center hover:bg-gray-800">
          <div class="mr-3">
            <img src="/assets/img/customers.png" alt="Customers" class="w-5 h-5" />
          </div>
          Customers
        </NuxtLink>

        <NuxtLink to="/admin/support" class="text-gray-400 p-3 rounded-lg flex items-center hover:bg-gray-800">
          <div class="mr-3">
            <img src="/assets/img/support.png" alt="Support" class="w-5 h-5" />
          </div>
          Support
        </NuxtLink>

        <NuxtLink to="/admin/settings" class="text-gray-400 p-3 rounded-lg flex items-center hover:bg-gray-800">
          <div class="mr-3">
            <img src="/assets/img/settings.png" alt="Settings" class="w-5 h-5" />
          </div>
          Settings
        </NuxtLink>
      </nav>

      <!-- Plan Status -->
      <div v-if="false" class="mt-auto border-t border-gray-800 pt-4">
        <div class="text-white mb-2 font-cinzel">YOUR PLAN</div>
        <div class="space-y-2">
          <div class="flex justify-between text-sm">
            <span class="text-gray-400">Emails sent</span>
            <span class="text-white">50 of 100</span>
          </div>
          <div class="w-full bg-gray-800 rounded-full h-2">
            <div class="bg-red-500 h-2 rounded-full" style="width: 50%"></div>
          </div>
          
          <div class="flex justify-between text-sm">
            <span class="text-gray-400">SMS sent</span>
            <span class="text-white">10 of 50</span>
          </div>
          <div class="w-full bg-gray-800 rounded-full h-2">
            <div class="bg-red-500 h-2 rounded-full" style="width: 20%"></div>
          </div>

          <div class="flex justify-between text-sm">
            <span class="text-gray-400">Daily requests</span>
            <span class="text-white">60 of 100</span>
          </div>
          <div class="w-full bg-gray-800 rounded-full h-2">
            <div class="bg-red-500 h-2 rounded-full" style="width: 60%"></div>
          </div>
        </div>
        <button class="text-red-500 text-sm mt-4 hover:text-red-400">Make an upgrade</button>
      </div>
    </div>

    <!-- Main Content -->
    <div class="flex-1">
      <!-- Header -->
      <div class="flex justify-between items-center p-4 border-b border-gray-800">
        <div class="flex-1 mx-4">
          <div class="relative">
            <input type="text" placeholder="Search here" 
                   class="w-full bg-gray-900 border border-gray-700 rounded-lg px-4 py-2 text-gray-300 focus:outline-none focus:border-red-500" />
            <button class="absolute right-3 top-2">
              <svg class="w-5 h-5 text-gray-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" stroke-width="2"/>
              </svg>
            </button>
          </div>
        </div>
        <div class="flex items-center">
          <button class="p-2 hover:bg-gray-800 rounded-lg mr-2">
            <svg class="w-6 h-6 text-red-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" stroke-width="2"/>
            </svg>
          </button>
          <div class="flex items-center bg-gray-900 rounded-lg p-1">
            <div class="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center text-white font-semibold">
              MJ
            </div>
            <div class="ml-2 mr-4">
              <div class="text-sm text-white">Marc Jacob</div>
              <div class="text-xs text-gray-400">marcj@goodmail.io</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Page Content -->
      <div class="p-8">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useSupabaseClient } from '#imports'
import useAuth from '~/composables/useAuth'

const { user } = useAuth()
</script>

<style>
.font-cinzel {
  font-family: 'Cinzel', serif;
}
</style> 